import { bool, func, oneOfType, shape, string } from 'prop-types'

import noop from 'shared/utils/noop'
import OffCanvasBody from 'views/components/organisms/OffCanvas/OffCanvasBody'
import OffCanvasHeader from 'views/components/organisms/OffCanvas/OffCanvasHeader'
import OffcanvasLogoutItem from 'views/components/organisms/OffCanvas/OffCanvasLogoutItem'
import { offCanvasCategory, shopLanguagesType } from 'views/utils/propTypes'

const OffCanvasEntryView = ({
  data,
  closeMenuHandler,
  userData,
  goNextHandler,
  language,
}) => (
  <div
    className="o-OffCanvasView o-OffCanvasView--entry"
    aria-labelledby="OffCanvasViewHeader"
    data-clientside-hook="menu"
  >
    <OffCanvasHeader closeMenuHandler={closeMenuHandler} userData={userData} />

    <OffCanvasBody
      data={data}
      goNextHandler={goNextHandler}
      userLoggedIn={userData?.isLoggedIn}
      language={language}
    />
    {userData?.isLoggedIn && <OffcanvasLogoutItem />}
  </div>
)

OffCanvasEntryView.propTypes = {
  data: offCanvasCategory.isRequired,
  language: oneOfType([string, shopLanguagesType]),
  userData: shape({ isLoggedIn: bool, name: string }),
  closeMenuHandler: func,
  goNextHandler: func,
}

OffCanvasEntryView.defaultProps = {
  language: null,
  userData: null,
  closeMenuHandler: noop,
  goNextHandler: () => noop,
}

export default OffCanvasEntryView
